var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#6F41D8",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.717 6.236a.693.693 0 0 0-.669 0l-1.535.883-1.043.574-1.535.882a.69.69 0 0 1-.67 0l-1.22-.69a.657.657 0 0 1-.334-.556V5.97c0-.23.118-.441.335-.557l1.2-.67a.692.692 0 0 1 .67 0l1.2.67a.658.658 0 0 1 .334.556v.882l1.043-.594v-.882a.619.619 0 0 0-.334-.556L5.935 3.553a.69.69 0 0 0-.67 0L3.003 4.818a.619.619 0 0 0-.334.556v2.55c0 .23.118.44.334.556l2.264 1.265a.693.693 0 0 0 .669 0l1.535-.863 1.043-.594 1.535-.863a.69.69 0 0 1 .67 0l1.2.671a.656.656 0 0 1 .334.556v1.36c0 .23-.117.441-.334.557l-1.2.69a.691.691 0 0 1-.67 0l-1.2-.671a.658.658 0 0 1-.335-.556V9.15l-1.043.595v.881c0 .23.118.441.335.556l2.263 1.265a.69.69 0 0 0 .669 0L13 11.182a.657.657 0 0 0 .335-.556v-2.55A.619.619 0 0 0 13 7.522l-2.282-1.285Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPol);
export default __webpack_public_path__ + "static/media/pol.a42e53c6fc4d0fb1f4581066bef33bfd.svg";
export { ForwardRef as ReactComponent };